import styled from 'styled-components';
import {
  getFixedSpace,
  mq,
  btnReset,
  gridContainer,
  setGridColumns,
  getSpace
} from '../../../stylesheets/tools';
import { fontFamilies } from '../../../stylesheets/settings';

const StyledAccessibilityMeta = styled.div`
  width: 100%;
  background: black;
  color: #fff;

  p {
    font-weight: 400;
    font-size: 18px;
    line-height: 1;
  }

  .accessibilityMeta__flyout {
    width: 100%;
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    max-width: 680px;
    padding-top: ${getSpace('120px')};

    ${mq('m')} {
      padding-top: ${getSpace('150px')};
    }

    ${mq('xl')} {
      padding: ${getFixedSpace('100px')} 0 ${getFixedSpace('180px')} 0;
      justify-content: center;
      max-width: 1120px;
    }
  }

  .accessibilityMeta__links {
    max-width: 540px;
    width: 100%;
    margin: 0 auto ${getFixedSpace('xl')} auto;

    ${mq('xl')} {
      max-width: 100%;
    }

    .accessibilityMeta__links-headline {
      margin-bottom: ${getFixedSpace('20px')};
    }
  }

  .accessibilityMeta__link-container {
    ${gridContainer()}
    ${setGridColumns('1fr', 1)}
    gap: 10px;

    ${mq('m')} {
      ${setGridColumns('1fr', 2)}
    }
    ${mq('xl')} {
      ${setGridColumns('1fr', 4)}
    }

    .accessibilityMeta__link-item {
      position: relative;
      border: 1px solid #595959;
      border-radius: 6px;
      width: 100%;
      display: flex;
      padding: 20px 25px;
      align-items: center;
      gap: 15px;
      transition: all 0.25s ease;

      &:hover {
        border-color: #fff;
        background-color: #1e1e1e;
      }

      ${mq('m')} {
        padding: 45px 25px 25px 25px;
      }

      .accessibilityMeta__link-image {
        display: block;
        max-height: 40px;
        max-width: 40px;

        ${mq('m')} {
          margin-bottom: auto;
          max-height: 50px;
          max-width: 50px;
        }
        ${mq('xl')} {
          margin: auto 0;
          max-height: 60px;
          max-width: 60px;
        }
      }

      a {
        margin: auto 0;
        font-size: 18px;
        word-break: break-word;

        .accessibilityMeta__link-stretched {
          position: absolute;
          inset: 0;
        }
      }

      ${mq('m')} {
        text-align: center;
        justify-content: center;
        flex-direction: column;
        aspect-ratio: 1 / 1;
      }
    }
  }
  .accessibilityMeta__settings {
    display: flex;
    gap: 20px;
    flex-direction: column;

    ${mq('m')} {
      flex-direction: row;
      gap: 40px;
    }
  }

  .accessibilityMeta__font-size,
  .accessibilityMeta__contrast {
    display: flex;
    flex-direction: column;
    width: 100%;
    line-height: 1;
  }

  .accessibilityMeta__headline {
    margin-bottom: ${getFixedSpace('xxxxs')};
    line-height: 1;
  }

  .accessibilityMeta__reset {
    ${btnReset}

    p {
      color: #fff;
      margin: 0;
      margin-right: ${getFixedSpace('s')};
    }
  }

  .accessibilityMeta__slider {
    padding-top: ${getFixedSpace('xxxs')};
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    max-width: 250px;

    ${mq('xl')} {
      width: auto;
    }
  }

  .accessibilityMeta__range-slider {
    flex-grow: 2;
  }

  .accessibilityMeta__indicator {
    font-family: ${fontFamilies.default};

    &.large {
      padding-left: ${getFixedSpace('xxs')};
      font-size: 42px;
      line-height: 1;
    }

    &.small {
      padding-right: ${getFixedSpace('xxs')};
      font-size: 24px;
      line-height: 1;
    }
  }
`;

export default StyledAccessibilityMeta;
